(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/pay-ticket.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/pay-ticket.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$tur$pay = svs.tur.pay,
  accountServices = _svs$tur$pay.account_services,
  dialogs = _svs$tur$pay.dialogs;
const createBetRequest = function () {
  var _ticket$skinId;
  let ticket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const searchParams = new URLSearchParams();
  const channelId = svs.ticketgames.ticketUtility.utils.constants.leia.lotteryChannel.WEB; 
  searchParams.append('channel', channelId);
  searchParams.append('gameCode', ticket.type);
  searchParams.append('stake', ticket.price * 100); 
  searchParams.append('revelationData[skinId]', (_ticket$skinId = ticket.skinId) !== null && _ticket$skinId !== void 0 ? _ticket$skinId : 1);
  searchParams.append('revelationData[themeId]', ticket.themeName);
  return {
    searchParams
  };
};
const buySingleTicket = async data => {
  const path = "".concat(svs.core.urlMapping.get('ticketsApi'), "/bet");
  const res = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: data
  });
  if (!res.ok) {
    throw new Error("bet failed: ".concat(res.statusText, " (").concat(res.status, ")"));
  }
  const response = await res.json();
  return {
    response
  };
};
const createTransactionItems = tickets => tickets.map(_ref => {
  let wagerId = _ref.wagerId,
    type = _ref.type,
    name = _ref.name,
    price = _ref.price;
  const data = {
    type,
    name,
    price
  };
  if (!wagerId || wagerId.toString().length < 3) {
    return data;
  }
  return _objectSpread(_objectSpread({}, data), {}, {
    extraData: {
      betId: wagerId
    }
  });
});
const buyTickets = async _ref2 => {
  let next = _ref2.next,
    tickets = _ref2.tickets;
  const ticket = tickets === null || tickets === void 0 ? void 0 : tickets[0];
  if (!ticket) {
    next({
      successfulTickets: [],
      failedTickets: []
    });
    return;
  }
  let delayedLoaderCall;
  try {
    var _wagerId$toString;
    delayedLoaderCall = gsap.delayedCall(2, () => {
      svs.ui.loader.show();
    });
    const _await$svs$ticketgame = await svs.ticketgames.ticketUtility.buySingleTicket(createBetRequest(ticket).searchParams),
      response = _await$svs$ticketgame.response;
    const wagerId = response === null || response === void 0 ? void 0 : response.receiptId;
    const successfulTickets = [_objectSpread(_objectSpread({}, ticket), {}, {
      wagerId
    })];
    const failedTickets = [];
    const transactionId = (wagerId === null || wagerId === void 0 || (_wagerId$toString = wagerId.toString()) === null || _wagerId$toString === void 0 ? void 0 : _wagerId$toString.length) > 1 ? wagerId : undefined; 
    svs.ticketgames.ticketUtility.utils.tracking.trackWonTicketPurchaseTransactions(createTransactionItems(successfulTickets), transactionId);
    svs.tur.pay.logger.info('Ticket payment success', wagerId);
    next({
      successfulTickets,
      failedTickets
    });
  } catch (e) {
    svs.tur.pay.logger.error("Ticket payment of ".concat(ticket.type, " failed: ").concat(e));
    next({
      successfulTickets: [],
      failedTickets: [ticket]
    });
  } finally {
    var _delayedLoaderCall;
    (_delayedLoaderCall = delayedLoaderCall) === null || _delayedLoaderCall === void 0 || _delayedLoaderCall.kill();
    svs.ui.loader.hide();
  }
};
const payTicket = function () {
  let _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    ticket = _ref3.ticket,
    _ref3$shouldConfirmPa = _ref3.shouldConfirmPayment,
    shouldConfirmPayment = _ref3$shouldConfirmPa === void 0 ? true : _ref3$shouldConfirmPa,
    onCancel = _ref3.onCancel,
    onDone = _ref3.onDone;
  let successfulTickets = [];
  let failedTickets = [];
  if (!ticket) {
    return;
  }
  const formatCurrency = svs.utils.format.CurrencyFromJupiterString;
  const totalCost = formatCurrency(ticket.price);
  const confirmPaymentOptions = {
    title: "Vill du betala ".concat(ticket.name, " f\xF6r ").concat(totalCost, " kr?"),
    messages: ['Observera att spelet inte går att annullera.']
  };
  const product = ticket === null || ticket === void 0 ? void 0 : ticket.branding;
  let accountBalance;
  const calls = [{
    in: () => ({
      price: totalCost,
      product
    }),
    fn: accountServices.playerSession
  }, {
    in: () => ({
      spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
    }),
    fn: accountServices.playerSpelpaus
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => ({
      price: totalCost,
      product
    }),
    fn: accountServices.accountBalance,
    out: args => {
      var _args = args;
      accountBalance = _args.accountBalance;
      return _args;
    }
  }, {
    fn: accountServices.playerDepositLimits
  }, ...(shouldConfirmPayment ? [{
    in: () => _objectSpread({
      price: totalCost,
      accountBalance
    }, confirmPaymentOptions),
    fn: dialogs.confirmPayment
  }] : []), {
    in: () => ({
      tickets: [ticket]
    }),
    fn: buyTickets,
    out: args => {
      var _args2 = args;
      successfulTickets = _args2.successfulTickets;
      failedTickets = _args2.failedTickets;
      return _args2;
    }
  }];
  const cancel = () => {
    onCancel === null || onCancel === void 0 || onCancel();
  };
  const done = () => {
    onDone === null || onDone === void 0 || onDone({
      successfulTickets,
      failedTickets
    });
  };
  svs.tur.pay.initPay({
    calls,
    cancel,
    done
  });
};
const fetchWager = async wagerId => {
  try {
    var _data$response;
    const data = await svs.tur.apiCaller.ticketgames.getPlayerWagerById({
      wagerId
    });
    return (_data$response = data.response) === null || _data$response === void 0 ? void 0 : _data$response.wager;
  } catch (error) {
    return undefined;
  }
};
setGlobal('svs.ticketgames.ticketUtility.constants.wager', {
  WAGER_RETRIES: 3,
  WAGER_RETRY_DELAY: 1000
});
const waitForWager = async function (wagerId) {
  let retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : svs.ticketgames.ticketUtility.constants.wager.WAGER_RETRIES;
  let delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : svs.ticketgames.ticketUtility.constants.wager.WAGER_RETRY_DELAY;
  await new Promise(resolve => {
    setTimeout(resolve, delay);
  });
  const wager = await svs.ticketgames.ticketUtility.fetchWager(wagerId);
  if (wager) {
    return wager;
  } else if (retries <= 0) {
    svs.ticketgames.ticketUtility.logger.info("Failed to fetch wager after ".concat(svs.ticketgames.ticketUtility.constants.wager.WAGER_RETRIES, " retries"));
    return undefined;
  }
  return await waitForWager(wagerId, retries - 1, delay);
};
setGlobal('svs.ticketgames.ticketUtility.payTicket', payTicket);
setGlobal('svs.ticketgames.ticketUtility.buySingleTicket', buySingleTicket);
setGlobal('svs.ticketgames.ticketUtility.fetchWager', fetchWager);
setGlobal('svs.ticketgames.ticketUtility.waitForWager', waitForWager);

 })(window);